import React, {
  PropTypes as T,
} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';

// Component
import SimulatorLeftEar from './SimulatorLeftEar.js';

const styles = {
  wrap: {
    padding: 24,
    backgroundColor: '#4a4a4a',
    display: 'block',
    height: 'calc(100vh - 150px)',
    '@media (max-width: 1024px)': {
      height: 'auto',
      padding: 44,
    }
  },
};

function SimulatorDefault() {
  return (
    <div style={styles.wrap} >
      <SimulatorLeftEar />
    </div>
  );
}

SimulatorDefault.propTypes = {
  step: T.number,
};

export default connect(
  state => ({
    step: state.Simulator.step,
  }),
)(radium(SimulatorDefault));



// WEBPACK FOOTER //
// ./containers/Simulators/SimulatorDefault.js